export default {
    isLoading: state => state.isLoading,
    skillGroups: state => state.skillGroups,

    skills: state => state.skillGroups
        .reduce((collect, { skills }) => {
            collect.push(...skills);
            return collect;
        }, []),
    // TODO: add findbyname for both sets
};



// WEBPACK FOOTER //
// ./src/taskflex/skills/store/_getters.js